import Conexion_api from "@/api/Conexion_api.js"

const validar_correo_debounce = function(correo){    
    this.mostrar_loader = true;
    Conexion_api({
        body: {
            correo: correo
        },
        evento: "login/validar_correo_debounce"
    }).then(respuesta => {   
        this.mostrar_loader = false;        
        if(!respuesta.data.datos.valido) this.error_debounce = 'Email invalido.'  
        else this.error_debounce = ""; 
        if(respuesta.data.error){                     
          this.$root.$emit('snackbar',{ color:"error", texto: respuesta.data.error})
          return;
        }           
        this.usuario.correo_valido = respuesta.data.datos.valido;
    }).catch(err => { 
    this.mostrar_loader = false;     
      err = String(err)
      this.$root.$emit('snackbar',{ color:"error", texto: err})                   
      console.error(err)
    }) 
}
export default validar_correo_debounce